var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39922 12.1001C3.01262 12.1001 2.69922 11.7867 2.69922 11.4001L2.69922 8.18843C2.69922 8.00125 2.77418 7.82187 2.90737 7.69035L9.17403 1.50202C9.44789 1.23158 9.88871 1.23297 10.1609 1.50512L13.2942 4.63846C13.5663 4.91061 13.5677 5.35142 13.2973 5.62528L7.10896 11.8919C6.97744 12.0251 6.79806 12.1001 6.61089 12.1001L3.39922 12.1001ZM4.09922 10.7001L6.31835 10.7001L11.8124 5.13653L9.66278 2.98694L4.09922 8.48096L4.09922 10.7001Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30078 14C1.30078 13.6134 1.61418 13.3 2.00078 13.3H14.0008C14.3874 13.3 14.7008 13.6134 14.7008 14C14.7008 14.3866 14.3874 14.7 14.0008 14.7H2.00078C1.61418 14.7 1.30078 14.3866 1.30078 14Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4043 7.39498L7.4043 4.39498L8.39425 3.40503L11.3942 6.40503L10.4043 7.39498Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.9fc9e9f5ced99f6b789014ba1990b228.svg";
export { ForwardRef as ReactComponent };